import React, { useState } from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import Row from "../../common/layout/row";
import Button from "../../common/button/button";
import ContentCardBody from "../../common/template/contentCardBody";
import Grid from "../../common/layout/grid";

export function YesNoModal(props) {
    if (!props.visible) return null;

    const [noButtonHover, setNoButtonHover] = useState(true);

    function eventHover() {
        setNoButtonHover(false);
    }

    const title = props.title || "";
    return (
        <ModalAlert titulo={title} estiloTitulo={{ paddingTop: 30 }}>
            <ContentCardBody style={{ marginBlock: 20 }}>
                <Row alignCenter>
                    <Grid cols="12 12 6 6">
                        <Row alignCenter style={{ paddingRight: 5 }}>
                            <Grid cols="12 12 6 6">
                                <Button text={"Não"} title="Não" type={"dark"} startHover={noButtonHover} event={props.handleNo} />
                            </Grid>
                            <Grid cols="12 12 6 6">
                                <Button text={"Sim"} title="Sim" type={"dark"} event={props.handleYes} eventHover={eventHover} />
                            </Grid>
                        </Row>
                    </Grid>
                </Row>
            </ContentCardBody>
        </ModalAlert>
    );
}
